<template>
  <div class="partnerup">
    <div class="partnerup__header">
      <img class="desktop" src="img/staticpage/partnerup-banner.jpg" alt="">
      <img class="mobile" src="img/staticpage/partnerup-banner-mobile.jpg" alt="">
      <div class="partnerup__header__text">
        <p class="little">Partner Up ADX Asia</p>
        <p class="big">Join as Our Partner<br/>for Advertisement</p>
      </div>
    </div>
    <div class="partnerup__row">
      <div class="partnerup__row__number">1</div>
      <div class="partnerup__row__description">
        <p class="partnerup__row__description__title">Earn Money as ADX Asia Host</p>
        <p>
          Punya ruang kosong di tempat bisnis Anda? Bingung ingin dijadikan apa? Jadikan tempat iklan! Dengan menjadi host ADX Asia, Anda bisa dengan mudah menghasilkan uang dari ruang kosong di tempat bisnis Anda. Caranya juga mudah, Anda tinggal kirim foto tempat bisnis Anda beserta deskripsi detail tempat bisnis Anda ke host@adxasia.co.id.
        </p>
        <p>
          Bagaimana kalau iklan yang mau dipasang di tempat bisnis Anda tidak sesuai dengan regulasi bisnis Anda? Tidak perlu takut karena ADX Asia tidak akan sembarangan memasang iklan di tempat Anda tanpa izin. Sebagai pemilik bisnis, Anda berhak untuk memeriksa dulu apakah iklan yang akan ditampilkan di tempat Anda sesuai dengan regulasi bisnis Anda. Kalau sudah OK, ADX baru akan memasangnya. 
        </p>
        <p>
          Soal uang, Anda juga tidak perlu khawatir! Dengan sistem pembayaran ADX yang aman, Anda tidak perlu pusing mengurusnya. Pemasang iklan akan dikenakan biaya sebelum mereka memasang iklan. Sebagai pemilik tempat, Anda akan dibayar setelah campaign selesai (tapi minus service fee ya!). Tenang saja, uang akan dikirim langsung ke akun bank Anda!
        </p>
      </div>
      <div class="partnerup__photo"><img src="img/staticpage/partnerup-img1.jpg" alt=""></div>
    </div>
    <div class="partnerup__row">
      <div class="partnerup__photo2"><img src="img/staticpage/partnerup-img2.jpg" alt=""></div>
      <div class="partnerup__row__number">2</div>
      <div class="partnerup__row__description">
        <p class="partnerup__row__description__title">Become ADX Asia Content Partner</p>
        <p>
          Perhatian, perhatian! ADX Asia sedang mencari perusahaan media, content creater, komunitas, dan organisasi yang tertarik untuk menjadi partner konten ADX Asia. Sebagai partner media, kami berharap Anda bisa membantu kami agar lebih dikenal melalui kegiatan PR. Masih belum yakin untuk bermitra dengan ADX? Kami bisa membantu Anda menampilkan konten Anda melalui digital screen ADX di lebih dari 400 lokasi di seluruh Indonesia.
        </p>
      </div>
      <div class="partnerup__photo2--mobile"><img src="img/staticpage/partnerup-img2.jpg" alt=""></div>
    </div>
    <div class="partnerup__row">
      <div class="partnerup__row__number">3</div>
      <div class="partnerup__row__description">
        <p class="partnerup__row__description__title">Become ADX ASIA Client Solution Partner</p>
        <p>
          Wanted: Client Solution Partner. Terdengar seperti Anda? Mungkin Anda yang sedang kami cari! ADX membuka kesempatan bagi Anda yang ingin membantu ADX menjual produk-produk kami. Tenang saja, Anda tidak perlu investasi – tinggal jual produk ADX dan langsung masuk ke dashboard ADX untuk mendapatkan penghasilan. Kalau berani, hubungi support@adxasia.co.id.
        </p>
      </div>
      <div class="partnerup__photo"><img src="img/staticpage/partnerup-img3.jpg" alt=""></div>
    </div>
    <div class="partnerup__footer">
      <img src="img/staticpage/partnerup-join.jpg" alt="">
      <div class="getstarted">
        <p class="big">Ready to Earn?</p>
        <a :href="'/contact-us?subject=partnerup'"><button class="btn-large primary">Get Started</button></a>
      </div>
    </div>
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron/Category'

export default {
    name: 'adx-partner-up',
    components: {
      'adx-jumbotron': Jumbotron
    },
    props: {

    },
    data() {
      return {
        jumbotronImage: 'img/staticpage/rounded@2x.png',
      }
    },
    computed: {

    },
    watch: {

    },
    beforeCreate() {

    },
    created() {

    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    activated() {

    },
    deactivated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      
    }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>